// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__hDaj8"};